import type { Question } from "@/domain/entities";
import { Button } from "../Button";
import { useLocale } from "../../i18n/LocaleProvider";
import styles from "./questions.module.css";

type SingleQuestion = Extract<Question, { type: "single" }>;

interface Props {
  question: SingleQuestion;
  value: string | undefined;
  onSubmit: (value: string) => void;
}

export function SingleInput({ question, value, onSubmit }: Props) {
  const { pick } = useLocale();
  return (
    <div className={styles.stack}>
      {question.options.map((option) => (
        <Button key={option.id} block selected={value === option.id} onClick={() => onSubmit(option.id)}>
          {pick(option.text)}
        </Button>
      ))}
    </div>
  );
}
